import "../SuspenseFallback/style.css";
import logo from "../../assets/images/mG_logo.svg";

interface LoaderInterface {
  fullscreen?: boolean;
  side?: boolean;
  table?: boolean;
}

const CustomLoader = ({ fullscreen, side, table }: LoaderInterface) => {
  return (
    <div
      className={`flex ${side ? "" : "justify-center"} ${table ? "mb-6" : ""}`}
      style={{ height: fullscreen ? "100vh" : "initial" }}
    >
      <img
        src={logo}
        alt="Mitigate Risk logo"
        className="fallback__logo"
        style={{
          height: fullscreen ? "12rem" : "2rem",
          width: fullscreen ? "12rem" : "2rem",
          margin: side ? "0" : "auto",
        }}
      />
    </div>
  );
};

export default CustomLoader;
